import { useEffect, useState } from "react";
import Chart from "react-google-charts";
import { LabeledInt } from "../../../models";
import { ReportService } from "../../../services/SubmissionService";

export default function FilingMapWidget() {
    const [reportData, setReportData] = useState([] as LabeledInt[]);
    useEffect(() => {
        ReportService.getByState({ attorneyId: "" }).then(
            (resp) => {
                setReportData(resp);
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);
    return (
        <div className="card">
            <div className="card-body">
                <div className="card-widgets">
                    <a href="javascript:;" data-toggle="reload">
                        <i className="mdi mdi-refresh"></i>
                    </a>
                    <a
                        data-bs-toggle="collapse"
                        href="#cardCollpase4"
                        role="button"
                        aria-expanded="false"
                        aria-controls="cardCollpase4"
                    >
                        <i className="mdi mdi-minus"></i>
                    </a>
                    <a href="javascript:;" data-toggle="remove">
                        <i className="mdi mdi-close"></i>
                    </a>
                </div>
                <h4 className="header-title mb-0">
                    Last 30 Day Filings By Location
                </h4>

                <div id="cardCollpase4" className="collapse pt-3 show">
                    <Chart
                        height={433}
                        chartType="GeoChart"
                        loader={<div>Loading Chart</div>}
                        data={[
                            ["State", "Submissions"],
                            ...reportData.map((v) => [v.name, v.value]),
                        ]}
                        options={{
                            title: "Filing Map",
                            region: "US",
                            resolution: "provinces",
                            colorAxis: { colors: ["#FF0000", "#4374e0"] },
                        }}
                        mapsApiKey="AIzaSyBrS-KkNjZlfQeltXUCUlVOE_zgQu-5XNA"
                        legendToggle
                    />
                </div>
            </div>
        </div>
    );
}
